import { AuthService } from '../auth.service';
import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {


  // tslint:disable-next-line:variable-name
  constructor(private _authService: AuthService, private _router: Router, private activatedRoutes: ActivatedRoute) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this._authService.isAuthenticated()) {
      return true;
    }

    // this._router.navigate(['/health/family/login']);
    // console.log('redirecting to user login');
    // throw new Error('');
    return false;
  }

}
